import {
  SUBMIT_XM_DEVICE_PAYMENT, SUBMIT_XM_DEVICE_PAYMENT_SUCCESS, SUBMIT_XM_DEVICE_PAYMENT_FAILURE,
  REVIEW_XM_DEVICE_PAYMENT,
} from '../actions/mobileDevicePayment';

const INITIAL_STATE = { submitting: false };

export default function mobilePaymentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SUBMIT_XM_DEVICE_PAYMENT:
      return {
        ...state,
        submitting: true,
      };
    case SUBMIT_XM_DEVICE_PAYMENT_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: false,
        review: {
          ...state.review,
          cardNumber: null,
          cvv: null,
          expirationMonth: null,
          expirationYear: null,
          bankNumber: null,
          routeNumber: null,
        },
        confirm: {
          ...state.review,
          // Clear PCI
          cardNumber: null,
          cvv: null,
          expirationMonth: null,
          expirationYear: null,
          bankNumber: null,
          routeNumber: null,
          ...action.payload,
        },
      };
    case SUBMIT_XM_DEVICE_PAYMENT_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
      };
    case REVIEW_XM_DEVICE_PAYMENT:
      return {
        ...state,
        confirm: null,
        review: action.payload,
      };
    default:
      return state;
  }
}
